import { render, staticRenderFns } from "./RoleSearchDropdown.vue?vue&type=template&id=c3bd2e4a"
import script from "./RoleSearchDropdown.vue?vue&type=script&lang=js"
export * from "./RoleSearchDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports